import { useState } from 'react';
import { api, ApiRequestError } from '../api/client.js';

/** Pflichtwechsel nach Anlage oder administrativem Reset. */
export function ChangePasswordForm({
  onDone,
}: {
  onDone: () => void;
}): React.JSX.Element {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    try {
      await api.post('/api/me/password', { currentPassword: current, newPassword: next });
      onDone();
    } catch (err) {
      setError(err instanceof ApiRequestError ? err.message : 'Nicht erreichbar.');
    }
  }

  return (
    <form className="card login" onSubmit={submit}>
      <h2>Passwort festlegen</h2>
      <p className="note">
        Bitte legen Sie vor der weiteren Arbeit ein eigenes Passwort fest (mindestens 10
        Zeichen).
      </p>
      <label htmlFor="pw-current">Bisheriges Passwort</label>
      <input
        id="pw-current"
        type="password"
        autoComplete="current-password"
        value={current}
        onChange={(e) => setCurrent(e.target.value)}
        required
      />
      <label htmlFor="pw-next">Neues Passwort</label>
      <input
        id="pw-next"
        type="password"
        autoComplete="new-password"
        minLength={10}
        value={next}
        onChange={(e) => setNext(e.target.value)}
        required
      />
      {error !== null && <p role="alert">{error}</p>}
      <button type="submit" className="primary">
        Speichern
      </button>
    </form>
  );
}
